<template>
    <div class="wrapper activityWrapper">
      <Inplace :closable="true" :active="isActive">
      <template #display>
        <DataTable :value="currentActivities" dataKey="indexId" @row-select="onRowSelect" :paginator="false">
        <template #header>
           <div class="row">
            <div class="col-md-1"><p>{{orderRow.state}}</p></div>
            <div class="col-md-1"><p>{{orderRow.startTime}}</p></div>
            <div class="col-md-1"><p>{{orderRow.endTime}}</p></div>
            <div class="col-md-2"><p>{{orderRow.driverName}}</p></div>
            <div class="col-md-2"><p>{{orderRow.truckName}}</p></div>
            <div class="col-md-2"><p>{{orderRow.articleName}}</p></div>
            <div v-if="showTotal" class="col-md-3"><p>{{totalAmount}} </p></div>
          </div>
        </template>
      </DataTable>
      </template>
      <template #content>
      <DataTable :value="currentActivities" selectionMode="single" :reorderableColumns="true" @row-reorder="onRowReorder" :selection.sync="selectedActivity" dataKey="indexId" @row-select="onRowSelect" :paginator="false">
        <template #header>
           <div class="row">
            <div class="col-md-1"><p><Dropdown v-model="orderRow.state" :disabled="editAllowed ? false : true" optionValue="name" :options="dropDownStates" optionLabel="name" placeholder="Välj Status" /></p></div>
            <div class="col-md-1"><p>{{orderRow.startTime}}</p></div>
            <div class="col-md-1"><p>{{orderRow.endTime}}</p></div>
            <div class="col-md-2"><p><Dropdown v-model="orderRow.driverId" :disabled="editAllowed ? false : true" optionValue="id" :options="drivers" optionLabel="name" placeholder="Välj chaufför"  @change="driverChange($event.value)" /></p></div>
            <div class="col-md-2"><p>{{orderRow.truckName}}</p></div>
            <div v-if="orderType == 'hydro'" class="col-md-2"><p><Dropdown v-model="orderRow.articleId" :disabled="editAllowed ? false : true" optionValue="id" :options="articles" optionLabel="name" placeholder="Välj artikel" @change="articleChange($event.value)" /></p></div>
            <div v-else class="col-md-2"></div>
            <div v-if="showTotal" class="col-md-2"><p>{{totalAmount}}</p></div>
            <div v-else class="col-md-2"></div>
            <div class="col-md-1 text-right editOrderRowWrapper"><Button :class="editAllowed ? 'p-button-success' : 'p-button-info'" type="button" :icon="editAllowed ? 'pi pi-unlock' : 'pi pi-lock'" @click="editAllowed = !editAllowed"></Button></div>
          </div>
        </template>
            <Column :rowReorder="true" headerStyle="width: 3rem" :reorderableColumn="false" />
            <Column field="name" header="Aktivitet"></Column>
            <Column field="user" header="Chaufför"></Column>
            <Column field="startTime" header="Starttid"></Column>
            <Column field="endTime" header="Sluttid"></Column>
            <Column field="amount" header="Antal"></Column>
            <Column field="deliveryPlaceName" header="Leveransställe">
              <template #body="slotProps">
                {{slotProps.data.deliveryPlaceName}}<span class="ml-1" title="Har läst instruktionerna" v-if="slotProps.data.hasReadInstructions == true"><i class='pi pi-check'></i></span>
              </template>
            </Column>
            <Column field="comment" header="Kommentar"></Column>
            <Column field="cargoPlace" header="Väntplats"></Column>
            <Column field="washPlace" header="Tvättplats"></Column>
            <Column header="Oaviserad" headerStyle="width: 100px" bodyStyle="text-align: center">
              <template #body="slotProps">
                  <span v-if="slotProps.data.unAnnounced == true"><i class='pi pi-check'></i></span>
              </template>
            </Column>
        <template #footer>
          <div style="text-align:left">
            <Button label="Lägg till" icon="pi pi-plus" @click="addNewActivity" />
            <Button label="Ta bort hela raden" class="p-button-danger" icon="pi pi-trash" @click="removeOrderRow" />
        </div>
        </template>
         </DataTable>
      </template>
      </Inplace>
    <Dialog :visible.sync="dialogVisible" :style="{width: '400px'}" header="Aktivitet" :modal="true">
    <div class="p-cardialog-content">
        <div class="p-grid p-fluid" v-if="activity">
            <div class="p-col-4"><label for="name">Aktivitet</label></div>
            <div class="p-col-8">
              <Dropdown v-model="activity.name" optionValue="value" :options="dropDownActivities" @change="activityChange($event.value)" optionLabel="name" placeholder="Välj aktivitet" />
            </div>
              <div v-if="selectedAction != null" class="p-col-4"><label for="user">Chaufför</label></div>
              <div v-if="selectedAction != null" class="p-col-8">
                <InputText id="user" v-model="activity.user" autocomplete="off" />
              </div>
              <div v-if="selectedAction !='Retur' && selectedAction != null" class="p-col-4"><label for="startTime">Starttid</label></div>
              <div v-if="selectedAction !='Retur' && selectedAction != null" class="p-col-8">
                  <Calendar id="startTime" v-model="activity.startTime" :showTime="true" hourFormat="24" :locale="sv" dateFormat="yy-mm-dd" />
              </div>
              <div v-if="selectedAction !='Retur' && selectedAction != null" class="p-col-4"><label for="endTime">Sluttid</label></div>
              <div v-if="selectedAction !='Retur' && selectedAction != null" class="p-col-8">
                  <Calendar id="endTime" v-model="activity.endTime" :showTime="true" hourFormat="24" :locale="sv" dateFormat="yy-mm-dd" />
              </div>
              <div v-if="selectedAction != null && selectedAction !='Rast' && selectedAction !='Väntetid' && selectedAction !='Sparad' && selectedAction !='Avslutad'" class="p-col-4"><label for="amount">Antal</label></div>
              <div v-if="selectedAction != null && selectedAction !='Rast' && selectedAction !='Väntetid' && selectedAction !='Sparad' && selectedAction !='Avslutad'" class="p-col-8">
                  <InputText id="amount" v-model="activity.amount" autocomplete="off" />
              </div>
              <div v-if="selectedAction != null && (selectedAction == 'Lossar' || selectedAction == 'Retur')" class="p-col-4"><label for="deliveryPlace">Leveransställe</label></div>
              <div v-if="selectedAction != null && (selectedAction == 'Lossar' || selectedAction == 'Retur')" class="p-col-8">
                <Dropdown v-model="activity.deliveryPlaceName" optionValue="name" :options="currentCustomerPlaces" optionLabel="name" placeholder="Välj leveransställe" />
              </div>
              <div v-if="selectedAction != null" class="p-col-4"><label for="comment">Kommentar</label></div>
              <div v-if="selectedAction != null" class="p-col-8">
                  <InputText id="comment" v-model="activity.comment" autocomplete="off" />
              </div>
              <div v-if="selectedAction != null && selectedAction =='Väntetid'" class="p-col-4"><label for="comment">Plats</label></div>
              <div v-if="selectedAction != null && selectedAction =='Väntetid'" class="p-col-8">
                <Dropdown v-model="activity.cargoPlace" optionValue="value" :options="cargoPlaces" optionLabel="name" placeholder="Välj plats" />
              </div>
              <div v-if="selectedAction =='Tvätt' && selectedAction != null" class="p-col-4"><label for="washPlace">Tvättplats</label></div>
              <div v-if="selectedAction =='Tvätt' && selectedAction != null" class="p-col-8">
                <Dropdown v-model="activity.washPlace" optionValue="value" :options="dropDownWashPlaces" optionLabel="name" placeholder="Välj tvättplats" />
              </div>
              <div v-if="selectedAction =='Lossar' && selectedAction != null" class="p-col-4"><label for="unAnnounced">Oaviserad</label></div>
              <div v-if="selectedAction =='Lossar' && selectedAction != null" class="p-col-8">
                <Checkbox v-model="activity.unAnnounced" :binary="true" />
              </div>
        </div>
    </div>
    <template #footer>
        <Button v-if="selectedAction != null" label="Ta bort" icon="pi pi-times" @click="deleteActivity" class="p-button-danger" />
        <Button v-if="selectedAction != null" label="Spara" icon="pi pi-check" :disabled="activity.name.length === 0 || activity.user.length === 0" @click="saveActivity" class="p-button-success" />
    </template>
</Dialog>
</div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import Calendar from 'primevue/calendar'
import { bus } from '../../main'
import uuidv4 from 'uuid/v4'
import Inplace from 'primevue/inplace'
import moment from 'moment'
export default {
  components: {
    DataTable,
    Column,
    Button,
    Dialog,
    InputText,
    Dropdown,
    Calendar,
    Inplace,
    Checkbox
  },
  data () {
    return {
      editAllowed: false,
      dialogVisible: false,
      activity: null,
      selectedActivity: null,
      selectedDropDownActivity: null,
      selectedAction: null,
      currentActivities: null,
      currentOrderRow: null,
      currentCustomerPlaces: [],
      isActive: false,
      totalAmount: 0,
      dropDownStates: [
        {name: 'Utförs', value: 'Utförs'},
        {name: 'Avslutad', value: 'Avslutad'}
      ],
      drivers: [],
      articles: [],
      dropDownActivities: [
        {name: 'Startad', value: 'Startad'},
        {name: 'Lastar', value: 'Lastar'},
        {name: 'Lossar', value: 'Lossar'},
        {name: 'Rast', value: 'Rast'},
        {name: 'Väntetid', value: 'Väntetid'},
        {name: 'Överblåsning', value: 'Överblåsning'},
        {name: 'Tvätt', value: 'Tvätt'},
        {name: 'Sparad', value: 'Sparad'},
        {name: 'Retur', value: 'Retur'},
        {name: 'Avslutad', value: 'Avslutad'}
      ],
      dropDownWashPlaces: [
        {name: 'Helsingborg', value: 'Helsingborg'},
        {name: 'Kund', value: 'Kund'},
        {name: 'Perstorp', value: 'Perstorp'},
        {name: 'Stenungsund', value: 'Stenungsund'},
        {name: 'Sölvesborg', value: 'Sölvesborg'},
        {name: 'Vetlanda', value: 'Vetlanda'}
      ],
      cargoPlaces: [],
      sv: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy-mm-dd',
        weekHeader: 'vk'
      }
    }
  },
  props: {
    activities: Array,
    customerPlaces: Array,
    orderRow: Object,
    isOpen: Boolean,
    showTotal: Boolean,
    orderType: String
  },
  watch: {
    activities: function (newVal, oldVal) {
      this.$props.activities = newVal
    },
    orderRow: function (newVal, oldVal) {
      this.$props.orderRow = newVal
    }
  },
  created () {
    this.countTotalAmount()
    if (this.$props.isOpen) {
      this.isActive = true
    }
    if (this.$props.customerPlaces) {
      this.currentCustomerPlaces = this.$props.customerPlaces
      this.currentCustomerPlaces.push({id: '0001', name: 'Retur Sölvesborg', artnr: ''})
      this.currentCustomerPlaces.push({id: '0002', name: 'Retur Vetlanda', artnr: ''})
    }
    this.currentActivities = this.$props.activities
    this.currentOrderRow = this.$props.orderRow
    for (let i = 0; i < this.currentActivities.length; i++) {
      this.currentActivities[i].indexId = i
    }
    this.getDrivers()
    this.getArticles()
    this.getCargoPlaces()
  },
  methods: {
    driverChange (id) {
      let selectedDriver = this.drivers.find(x => x.id === id)
      this.currentOrderRow.driverName = selectedDriver.name
    },
    articleChange (id) {
      let selectedArticle = this.articles.find(x => x.id === id)
      this.currentOrderRow.articleName = selectedArticle.name
    },
    getDrivers () {
      this.$http
        .get('/api/users/drivers')
        .then(response => {
          var users = response.data
          for (var i = 0; i < users.length; i++) {
            this.drivers.push({'id': users[i].id, 'name': users[i].firstName + ' ' + users[i].lastName})
          }
        })
        .catch(error => console.log(error))
    },
    getArticles () {
      this.$http
        .get('/api/objectdatas/objectdescriptionid/17')
        .then(response => {
          var articles = response.data
          for (var i = 0; i < articles.length; i++) {
            this.articles.push({'id': articles[i].data.articleId, 'name': articles[i].data.name})
          }
        })
        .catch(error => console.log(error))
    },
    getCargoPlaces () {
      this.$http
        .get('/api/objectdatas/objectdescriptionid/24')
        .then(response => {
          var cargoPlaces = response.data
          for (var i = 0; i < cargoPlaces.length; i++) {
            this.cargoPlaces.push({'value': cargoPlaces[i].data.name, 'name': cargoPlaces[i].data.name})
          }
        })
        .catch(error => console.log(error))
    },
    countTotalAmount () {
      if (this.orderRow.endTime) {
        const pause = this.orderRow.actions.filter(a => a.name === 'Rast').reduce((prev, curr) => {
          return prev.add(moment(curr.endTime).diff(moment(curr.startTime)))
        }, moment.duration(0))
        const work = moment.duration(moment(this.orderRow.endTime).diff(moment(this.orderRow.startTime))).subtract(pause)
        // const duration = moment(moment(this.orderRow.endTime)).diff(moment(this.orderRow.startTime))
        let hours = Math.floor(moment.duration(work).asHours())
        let mins = Math.floor(moment.duration(work).asMinutes()) - hours * 60
        if (mins.toString().length < 2) {
          mins = '0' + mins
        }
        this.totalAmount = hours + ':' + mins
      }
    },
    addNewActivity () {
      let countActivites = this.activities.length
      this.activity = {id: uuidv4(), name: '', user: '', startTime: '', endTime: '', amount: '', deliveryPlace: '', comment: '', washPlace: '', indexId: countActivites}
      this.dialogVisible = true
    },
    deleteActivity () {
      let index = this.findIndexByActivity(this.activity.indexId)
      this.currentActivities = this.currentActivities.filter((val, i) => i !== index)
      bus.$emit('addedActivity', this.currentActivities, this.$props.orderRow.id, this.activity, 'delete')
      this.dialogVisible = false
      this.activity = null
      this.selectedActivity = null
      this.selectedAction = null
    },
    removeOrderRow () {
      let message = 'Vill du ta bort hela raden?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          bus.$emit('removedOrderRow', this.$props.orderRow.id)
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    saveActivity () {
      let index = -1
      if (this.activity.indexId !== undefined) {
        index = this.findIndexByActivity(this.activity.indexId)
      }
      let activities = [...this.currentActivities]
      if (this.activity.deliveryPlaceName !== '') {
        for (let i = 0; i < this.$props.customerPlaces.length; i++) {
          if (this.$props.customerPlaces[i].name === this.activity.deliveryPlaceName) {
            this.activity.deliveryPlaceId = this.$props.customerPlaces[i].id.toString()
            this.activity.deliveryPlaceArtNr = this.$props.customerPlaces[i].artnr
          }
        }
      }
      if (this.activity.startTime !== '') {
        let date = new Date(this.activity.startTime)
        let formattedDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + 'T' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2)
        this.activity.startTime = formattedDate
      }
      if (this.activity.endTime !== '') {
        let date = new Date(this.activity.endTime)
        let formattedDate = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + 'T' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2)
        this.activity.endTime = formattedDate
      }
      if (this.activity.amount !== '') {
        this.activity.amount = this.activity.amount.replace(',', '.')
      }
      if (index === -1) {
        activities.push(this.activity)
      } else {
        activities[index] = this.activity
      }
      bus.$emit('addedActivity', activities, this.$props.orderRow.id, this.activity, 'add')
      this.currentActivities = activities
      this.dialogVisible = false
      this.selectedAction = null
      this.activity = null
      this.selectedActivity = null
    },
    onRowSelect (event) {
      this.activity = {...event.data}
      if (this.activity.startTime !== '') {
        let date = new Date(this.activity.startTime)
        this.activity.startTime = date
      }
      if (this.activity.endTime !== '') {
        let date = new Date(this.activity.endTime)
        this.activity.endTime = date
      }
      this.selectedDropDownActivity = {name: event.data.name, value: event.data.name}
      this.selectedAction = event.data.name
      this.dialogVisible = true
    },
    onRowReorder (event) {
      this.currentActivities = event.value
      bus.$emit('changedActivitiesOrder', event.value, this.$props.orderRow.id)
    },
    generateActivity () {
      let result = ''
      let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let charactersLength = characters.length
      for (var i = 0; i < 8; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },
    findIndexByActivity (indexId) {
      let index = -1
      for (let i = 0; i < this.currentActivities.length; i++) {
        if (this.currentActivities[i].indexId === indexId) {
          index = i
          break
        }
      }
      return index
    },
    activityChange (event) {
      if (event) {
        this.selectedAction = event
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Activities/ActivityTable.vue